import React, { type CSSProperties } from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';

import { StoreIcon } from '../../../../components-shared/Icons/StoreIcon';
import { locationButtonStylesParams } from '../../Settings/Tabs/Design/LocationButton/stylesParams';
import { ICON_POSITION } from '../../constants';

import { classes } from './Header.st.css';
import { headerDataHooks } from './constants';

type IconLayout = Pick<CSSProperties, 'flexDirection' | 'alignItems'>;

const ICON_LAYOUT: Record<number, IconLayout> = {
  [ICON_POSITION.LEFT]: { flexDirection: 'row', alignItems: 'center' },
  [ICON_POSITION.RIGHT]: { flexDirection: 'row-reverse', alignItems: 'center' },
  [ICON_POSITION.TOP]: { flexDirection: 'column', alignItems: 'center' },
  [ICON_POSITION.BOTTOM]: {
    flexDirection: 'column-reverse',
    alignItems: 'center',
  },
};

type Props = {
  locationName: string;
  onClick: () => void;
};

export const LocationButton: React.FC<Props> = ({ locationName, onClick }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const showIcon = styles.get(
    locationButtonStylesParams.locationButtonShowIcon,
  );
  const iconSize = styles.get(
    locationButtonStylesParams.locationButtonIconSize,
  );
  const iconPosition = styles.get(
    locationButtonStylesParams.locationButtonIconPosition,
  );

  return (
    <TextButton
      className={classes.locationButton}
      priority={TextButtonPriority.secondary}
      onClick={onClick}
      aria-label={t('header_olo.locationName.ariaLabel', {
        name: locationName,
      })}
      data-hook={headerDataHooks.locationButton()}
    >
      <span
        className={classes.locationButtonContent}
        style={ICON_LAYOUT[iconPosition]}
      >
        {showIcon && (
          <span className={classes.locationButtonIcon}>
            <StoreIcon width={iconSize} height={iconSize} />
          </span>
        )}
        <span className={classes.locationButtonLabel}>{locationName}</span>
      </span>
    </TextButton>
  );
};
